import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "./pages/Landing";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                </Routes>
            </BrowserRouter>
            <Toaster
                position="bottom-center"
                toastOptions={{
                    style: {
                        background: "#F7F3EC",
                        border: "1px solid #E5DFD5",
                        color: "#2C2A28",
                        fontFamily: "Cormorant Garamond, serif",
                        fontSize: "1rem",
                        letterSpacing: "0.01em",
                    },
                }}
            />
        </div>
    );
}

export default App;
